import { render, staticRenderFns } from "./materials-tab.vue?vue&type=template&id=329efcf1&scoped=true"
import script from "./materials-tab.ts?vue&type=script&lang=js&external"
export * from "./materials-tab.ts?vue&type=script&lang=js&external"
import style0 from "./materials-tab.less?vue&type=style&index=0&id=329efcf1&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329efcf1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('329efcf1')) {
      api.createRecord('329efcf1', component.options)
    } else {
      api.reload('329efcf1', component.options)
    }
    module.hot.accept("./materials-tab.vue?vue&type=template&id=329efcf1&scoped=true", function () {
      api.rerender('329efcf1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/operational-data/op-data-entry-details/tabs/materials-tab/materials-tab.vue"
export default component.exports